import { Injectable } from "@angular/core";
import { ApiService } from "../api-service/api.service";
import { Apis } from "../API";

@Injectable({
  providedIn: "root"
})

export class ParametrageService {
  constructor(private apiService: ApiService) { }

  getListePrametrage(body:{type_parametrage?: string, code_parametrage?: string} = {}) {
    return this.apiService.post(Apis.parametrage.getListeParametrage, body);
  }

  getListeCodification(body: {
    type_codification?: string, 
    code_codification?: string, 
    type_parent?: string, 
    code_parent?: string
  } = {}) {
    return this.apiService.post(Apis.parametrage.getListeCodification, body);
  }

  getListeFichierParam(body: {
    type_objet?: string,
    type_demande?: string,
    type_sous_demande?: string
  } = {}) {
    return this.apiService.post(Apis.parametrage.getListeFichierParam, body);
  }

  getAnneeExistParModule() {
    return this.apiService.get(Apis.parametrage.getAnneeExistParModule);
  }

}
 